import $ from 'jquery';

if (window.dflipSrc) {
    let script = document.createElement('script');
    script.onload = () => {
        const flipbooks = document.querySelectorAll('[data-flipbook][data-src]');

        const observer = new IntersectionObserver((entries, observer) => {
            for (let entry of entries) {
                if (entry.isIntersecting) {
                    const flipbook = entry.target;
                    const pdf = flipbook.getAttribute('data-src');

                    let options = '';
                    let windowWidth = window.innerWidth;
                    let height = windowWidth * 1.4;
                    let heightInRem = '43.75rem';

                    if (window.matchMedia('(max-width: 1024px)').matches) {
                        if (height > 700) {
                            height = 700;
                        }
                        options = { height: heightInRem, duration: 800, pageMode: 1, backgroundColor: 'transparent', hard: 'none' };
                    } else {
                        height = windowWidth / 4 * 3 * 1.4;
                        if (height > 700) {
                            height = 700;
                        }
                        options = { height: heightInRem, duration: 800, pageMode: 2, backgroundColor: 'transparent', hard: 'none' };
                    }

                    if (pdf) {
                        $(flipbook).flipBook(pdf, options);
                    }

                    // Unobserve once loaded
                    observer.unobserve(flipbook);
                }
            }
        }, { threshold: 0.1 }); // Adjust threshold as needed

        // Observe each flipbook
        flipbooks.forEach(flipbook => observer.observe(flipbook));
    };

    script.src = window.dflipSrc;

    if (window.jQuery === undefined) {
        window.jQuery = $;
    }
    document.body.appendChild(script);
}
